import React from 'react'
import { useDispatch } from 'react-redux'
import { endOfDay, startOfDay } from 'date-fns'

import { Format, Parse } from 'services/Dates'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { Button } from 'components/Forms'
import { Card } from 'ui'

import { t } from 'translations'

const PayReportConfirmationModal = ({ requestReport, params, options }) => {
  const dispatch = useDispatch()

  const onSubmit = () => {
    const rangeStart = Format(startOfDay(Parse(params.rangeStart, { inFormat: 'date' })))
    const rangeEnd = Format(endOfDay(Parse(params.rangeEnd, { inFormat: 'date' })))

    requestReport({
      ...params,
      rangeStart,
      rangeEnd,
      removeMissingInfo: options.removeMissingInfo,
      filter: params
    })
    dispatch(closeModal())
  }

  return (
    <BaseModal hideButtons title="manager.reports.PAY_REPORT_CONFIRMATION_MODAL">
      <div className="mt-2">
        <Card maxHeight="10rem" className="bg-light pt-3 mb-3">
          <ul>
            <li>
              <b>{`${t('manager.reports.PAY_EXPORT_NETHRIS_REPORT.RANGE')}: `}</b>
              {`${params.rangeStart} ${t('DATE_RANGE')} ${params.rangeEnd}`}
            </li>
            <li>
              <b>{`${t('manager.reports.PAY_EXPORT_NETHRIS_REPORT.PERIOD_END')}: `}</b>
              {params.periodEnd}
            </li>
            <li>
              <b>{`${t('manager.reports.PAY_EXPORT_NETHRIS_REPORT.PERIOD')}: `}</b>
              {params.period}
            </li>
          </ul>
        </Card>
        <Button className="btn btn-primary mr-2" type="submit" text="actions.CONFIRM" onClick={onSubmit} />
        <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
          {t(`actions.CANCEL`)}
        </Button>
      </div>
    </BaseModal>
  )
}

export default PayReportConfirmationModal
